import { rootApi } from '../rootApi';

export const serviceBulletinReportApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getServiceBulletinReport: builder.query({
      query: (params) => {
        const queryParams = {
          PageNumber: params?.pageNumber ?? 1,
          PageSize: params?.pageSize ?? 10,
          LanguageId: params?.languageId ?? 1,
        };
      

        // Dynamic filters array
        if (params?.filters && params.filters.length > 0) {
          params.filters.forEach((filter, index) => {
            queryParams[`Filters[${index}].Column`] = filter.column;
            queryParams[`Filters[${index}].Operator`] = filter.operator;
            queryParams[`Filters[${index}].Value`] = filter.value;
          });
        }

        // Dynamic sorts array
        if (params?.sorts && params.sorts.length > 0) {
          params.sorts.forEach((sort, index) => {
            queryParams[`Sorts[${index}].Column`] = sort.column;
            queryParams[`Sorts[${index}].Direction`] = sort.direction;
          });
        }

        // Filter options request
        if (params?.includeFilterOptions) {
          queryParams.IncludeFilterOptions = params.includeFilterOptions;
          if (params?.filterOptionsColumns && params.filterOptionsColumns.length > 0) {
            params.filterOptionsColumns.forEach((col, index) => {
              queryParams[`FilterOptionsColumns[${index}]`] = col;
            });
          }
        }
        if (params?.chassisNo) {
          queryParams['ChassisNo'] = params.chassisNo;
        }
        if (params?.isApplied !== undefined && params?.isApplied !== null) {
          queryParams['IsApplied'] = params.isApplied;
        }
        
        return {
          url: 'v1/servicebulletin/getallreport',
          method: 'GET',
          params: queryParams,
        };
      },
      transformResponse: (response) => {
        if (response?.data) {
          return { 
            items: response.data.items ?? [], 
            totalCount: response.data.totalCount ?? 0,
            filterOptions: response.data.filterOptions ?? null
          };
        }
        return { items: [], totalCount: 0, filterOptions: null };
      },
      providesTags: ['ServiceBulletinReport'],
    }),

      getBulletinNoDropdownList: builder.query({
  query: ({ RowCount = 100, SearchText = '', LanguageId }) => ({
    url: 'v1/servicebulletin/getbulletinnodropdownlist',
    method: 'GET',
    params: {
      RowCount,
      SearchText: SearchText || undefined,
      LanguageId: LanguageId || undefined,
    },
  }),
  transformResponse: (response) => {
    if (response?.data?.items) {
      return response.data.items;
    }
    return [];
  },
}),

getServiceBulletinByBulletinNo: builder.query({
      query: (params) => {
        const queryParams = {
          BulletinNo: params.BulletinNo,
          PageSize: params.PageSize || 10,
          PageNumber: params.PageNumber || 1,
          LanguageId: params.LanguageId || 1,
        };

        // Dynamic filters array
        if (params.Filters && params.Filters.length > 0) {
          params.Filters.forEach((filter, index) => {
            queryParams[`Filters[${index}].Column`] = filter.column;
            queryParams[`Filters[${index}].Operator`] = filter.operator;
            queryParams[`Filters[${index}].Value`] = filter.value;
          });
        }

        // Dynamic sorts array
        if (params.Sorts && params.Sorts.length > 0) {
          params.Sorts.forEach((sort, index) => {
            queryParams[`Sorts[${index}].Column`] = sort.column;
            queryParams[`Sorts[${index}].Direction`] = sort.direction;
          });
        }

        // Filter options request
        if (params.IncludeFilterOptions) {
          queryParams.IncludeFilterOptions = params.IncludeFilterOptions;
          if (params.FilterOptionsColumns && params.FilterOptionsColumns.length > 0) {
            params.FilterOptionsColumns.forEach((col, index) => {
              queryParams[`FilterOptionsColumns[${index}]`] = col;
            });
          }
        }

        return {
          url: 'v1/servicebulletin/getbybulletinno',
          method: 'GET',
          params: queryParams,
        };
      },
      transformResponse: (response) => {
        if (response?.data) {
          return {
            items: response.data.items ?? [],
            totalCount: response.data.totalCount ?? 0,
            filterOptions: response.data.filterOptions ?? null,
          };
        }
        return { items: [], totalCount: 0, filterOptions: null };
      },
    }),
  }),


});

export const {
  useGetServiceBulletinReportQuery,
  useLazyGetServiceBulletinReportQuery,
  useGetBulletinNoDropdownListQuery,
  useGetServiceBulletinByBulletinNoQuery,
  useLazyGetServiceBulletinByBulletinNoQuery,
} = serviceBulletinReportApi;